export type EngagementType = 'Hospital employee' | 'Rental basis' | 'Visiting · revenue share'

export interface ProviderSchedule {
  day: string
  inPerson: string
  video: string
}

export interface Provider {
  id: string
  name: string
  photo: string
  department: string
  specialty: string
  qualifications: string
  pmdcNumber: string
  pmdcExpiry: string
  phone: string
  email: string
  cnic: string
  engagement: EngagementType
  contractReference: string
  sharePercent?: number
  monthlyRental?: number
  clinic: string
  room: string
  costCentre: string
  inPersonFee: number
  videoFee: number
  ipdRoundFee: number
  schedule: ProviderSchedule[]
  inPersonSlots: string[]
  videoSlots: string[]
  stampLine: string
}

export const providers: Provider[] = [
  {
    id: 'dr-imran-sethi',
    name: 'Dr. Imran Sethi',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/da13acf0-751d-4f45-bc1b-dca344105eab.jpg',
    department: 'Cardiology',
    specialty: 'Interventional Cardiology',
    qualifications: 'MBBS, FCPS (Cardiology)',
    pmdcNumber: 'PMDC 51234-P',
    pmdcExpiry: '30 Sep 2027',
    phone: '+92 300 4512774',
    email: 'imran.sethi@creativeenergy.health',
    cnic: '35202-4400123-7',
    engagement: 'Hospital employee',
    contractReference: 'EMP-CARD-011',
    clinic: 'Cardiology Clinic',
    room: 'C-204',
    costCentre: 'CC-CARD-OPD',
    inPersonFee: 3500,
    videoFee: 2800,
    ipdRoundFee: 3000,
    schedule: [
      { day: 'Monday', inPerson: '09:00 – 12:00, 14:30 – 16:00', video: '12:00 – 13:00' },
      { day: 'Wednesday', inPerson: '09:00 – 12:00, 14:30 – 16:00', video: '12:00 – 13:00' },
      { day: 'Friday', inPerson: '09:00 – 12:00', video: '12:00 – 13:00' },
    ],
    inPersonSlots: ['09:00', '10:00', '11:00', '14:30', '15:00'],
    videoSlots: ['12:00', '12:30', '13:00', '16:00', '16:30'],
    stampLine: 'Consultant Interventional Cardiologist',
  },
  {
    id: 'dr-nadia-qureshi',
    name: 'Dr. Nadia Qureshi',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/73e80e3c-da0e-4326-b867-4e6b33654f9a.jpg',
    department: 'Obstetrics & Gynaecology',
    specialty: 'Maternal–Fetal Medicine',
    qualifications: 'MBBS, FCPS (Obs & Gyn)',
    pmdcNumber: 'PMDC 39821-P',
    pmdcExpiry: '15 May 2028',
    phone: '+92 321 8886744',
    email: 'nadia.qureshi@creativeenergy.health',
    cnic: '35202-5500112-5',
    engagement: 'Visiting · revenue share',
    contractReference: 'VST-OG-042',
    sharePercent: 55,
    clinic: 'Women’s Health Centre',
    room: 'WH-11',
    costCentre: 'CC-OBGYN-OPD',
    inPersonFee: 3000,
    videoFee: 2400,
    ipdRoundFee: 2600,
    schedule: [
      { day: 'Tuesday', inPerson: '09:30 – 12:30, 14:00 – 16:00', video: '12:00 – 13:30' },
      { day: 'Thursday', inPerson: '09:30 – 12:30, 14:00 – 16:00', video: '12:00 – 13:30' },
      { day: 'Saturday', inPerson: '10:00 – 13:00', video: '—' },
    ],
    inPersonSlots: ['09:30', '10:30', '11:30', '14:00', '15:30'],
    videoSlots: ['12:00', '12:30', '13:30', '16:00'],
    stampLine: 'Consultant Obstetrician & Gynaecologist',
  },
  {
    id: 'dr-kamran-ali',
    name: 'Dr. Kamran Ali',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/a9a11f4f-e74b-4095-91e2-11d9d8326757.jpg',
    department: 'Internal Medicine',
    specialty: 'Internal & Acute Medicine',
    qualifications: 'MBBS, MRCP (UK)',
    pmdcNumber: 'PMDC 28716-P',
    pmdcExpiry: '12 Jan 2027',
    phone: '+92 333 6652190',
    email: 'kamran.ali@creativeenergy.health',
    cnic: '35202-2210456-1',
    engagement: 'Rental basis',
    contractReference: 'REN-MED-018',
    monthlyRental: 180000,
    clinic: 'General Medicine Clinic',
    room: 'GM-101',
    costCentre: 'CC-MED-OPD',
    inPersonFee: 2500,
    videoFee: 2000,
    ipdRoundFee: 2200,
    schedule: [
      { day: 'Monday', inPerson: '09:00 – 11:30, 14:30 – 16:00', video: '11:30 – 12:30' },
      { day: 'Tuesday', inPerson: '09:00 – 11:30, 14:30 – 16:00', video: '11:30 – 12:30' },
      { day: 'Thursday', inPerson: '09:00 – 11:30, 14:30 – 16:00', video: '11:30 – 12:30' },
    ],
    inPersonSlots: ['09:00', '09:30', '10:30', '14:30', '15:30'],
    videoSlots: ['11:30', '12:00', '12:30', '16:00'],
    stampLine: 'Consultant Physician',
  },
]

export function getProvider(id: string) {
  return providers.find((provider) => provider.id === id)
}
